var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aside-layer",attrs:{"expand":!_vm.collapse && _vm.asideCollapse},on:{"mouseover":_vm.asideOver,"mouseleave":_vm.asideLeave}},[_c('menuSide',{attrs:{"collapse":_vm.collapse}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }